(function () {
  'use strict';

  const cfg = window.PostPickupConfig || {};
  const t = cfg.texts || {};

  let selectedPoint = null;
  let selectedMethod = 'inpost';
  let orlenMap = null;
  let orlenCluster = null;
  let orlenPoints = [];

  const section = document.querySelector('.postpickup');
  if (!section) return;

  // Read URL params
  const params = new URLSearchParams(window.location.search);
  const orderNumber = params.get('order') || params.get('order_number');
  const orderId = params.get('order_id') || orderNumber;
  const customerEmail = params.get('email');

  // Show order number if present
  if (orderNumber) {
    const infoEl = document.getElementById('postpickup-order-info');
    const numEl = document.getElementById('postpickup-order-number');
    if (infoEl && numEl) {
      infoEl.hidden = false;
      numEl.textContent = '#' + orderNumber;
    }
  }

  const methodInputs = section.querySelectorAll('input[name="delivery-method"]');
  const widgets = section.querySelectorAll('[data-widget]');
  const selectionEl = section.querySelector('.delivery-picker__selection');
  const detailsEl = section.querySelector('.selection-details');
  const continueBtn = section.querySelector('.postpickup__confirm');
  const finalEl = document.getElementById('postpickup-final');

  // ===== Method change =====
  methodInputs.forEach(input => {
    input.addEventListener('change', e => {
      selectedMethod = e.target.value;
      selectedPoint = null;
      selectionEl.hidden = true;
      continueBtn.disabled = true;

      widgets.forEach(w => {
        w.hidden = w.dataset.widget !== selectedMethod;
      });

      if (selectedMethod === 'orlen' && !orlenMap) {
        initOrlenMap();
      }
    });
  });

  // ===== InPost =====
  window.postpickupInpostSelected = function(point) {
    if (selectedMethod !== 'inpost') return;
    if (!point || !point.name) return;

    let address = '';
    if (point.address_details) {
      address = [point.address_details.street, point.address_details.city]
        .filter(Boolean).join(', ');
    } else if (point.address) {
      address = [point.address.line1, point.address.line2]
        .filter(Boolean).join(', ');
    }

    selectedPoint = {
      type: 'inpost',
      code: point.name,
      address: address,
      name: point.name
    };
    updateSelection(`${t.inpostLabel} ${point.name}`, address || '—');
  };

  // ===== Orlen =====
  function initOrlenMap() {
    if (typeof L === 'undefined') { setTimeout(initOrlenMap, 200); return; }

    orlenMap = L.map('postpickup-orlen-map', {
      center: [52.0, 19.5],
      zoom: 6,
      scrollWheelZoom: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 18
    }).addTo(orlenMap);

    orlenCluster = L.markerClusterGroup({
      chunkedLoading: true,
      maxClusterRadius: 60
    });
    orlenMap.addLayer(orlenCluster);

    loadOrlenPoints();

    document.getElementById('postpickup-orlen-search').addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchOrlen(e.target.value.trim());
      }
    });

    orlenMap.on('popupopen', handlePopupOpen);
  }

  async function loadOrlenPoints() {
    const status = document.getElementById('postpickup-orlen-status');
    try {
      const res = await fetch(cfg.orlenPointsUrl, { cache: 'force-cache' });
      orlenPoints = await res.json();
      const markers = orlenPoints
        .filter(p => p.lat && p.lng)
        .map(p => {
          const m = L.marker([p.lat, p.lng]);
          m.bindPopup(buildPopupHtml(p));
          return m;
        });
      orlenCluster.addLayers(markers);
      status.textContent = `${orlenPoints.length} punktów`;
      status.classList.add('ok');
    } catch (err) {
      console.error('Orlen load failed:', err);
      status.textContent = 'Błąd ładowania';
      status.classList.add('err');
    }
  }

  function buildPopupHtml(p) {
    return `
      <div class="orlen-popup">
        <strong>${esc(p.name || p.id)}</strong><br>
        <span>${esc(p.street || '')}</span><br>
        <span>${esc(p.postCode || '')} ${esc(p.city || '')}</span>
        <button class="orlen-select-btn" data-id="${esc(p.id)}">${esc(t.selectPoint)}</button>
      </div>`;
  }

  function handlePopupOpen(e) {
    const btn = e.popup.getElement().querySelector('.orlen-select-btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const id = btn.dataset.id;
      const point = orlenPoints.find(x => String(x.id) === String(id));
      if (!point) return;
      selectedPoint = {
        type: 'orlen',
        code: point.id,
        address: `${point.street || ''}, ${point.postCode || ''} ${point.city || ''}`.trim().replace(/^,\s*/, ''),
        name: point.name
      };
      updateSelection(`${t.orlenLabel} — ${point.name}`, selectedPoint.address);
      orlenMap.closePopup();
    }, { once: true });
  }

  async function searchOrlen(query) {
    if (!query || query.length < 2) return;
    const postMatch = query.match(/^(\d{2})-?(\d{3})$/);
    if (postMatch) {
      const needle = `${postMatch[1]}-${postMatch[2]}`;
      const hit = orlenPoints.find(p => p.postCode === needle);
      if (hit) { orlenMap.setView([hit.lat, hit.lng], 13); return; }
    }
    try {
      const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query + ', Polska')}&format=json&limit=1&countrycodes=pl`;
      const res = await fetch(url, { headers: { 'Accept-Language': 'pl' } });
      const data = await res.json();
      if (data[0]) orlenMap.setView([parseFloat(data[0].lat), parseFloat(data[0].lon)], 13);
    } catch (err) { console.warn('Search failed:', err); }
  }

  // ===== Selection =====
  function updateSelection(title, address) {
    selectionEl.hidden = false;
    detailsEl.innerHTML = `<strong>${esc(title)}</strong><br><span>${esc(address)}</span>`;
    continueBtn.disabled = false;
  }

  // ===== Submit =====
  continueBtn.addEventListener('click', async () => {
    if (!selectedPoint) return;
    continueBtn.disabled = true;
    continueBtn.textContent = t.saving;

    const payload = {
      _subject: `Wybór paczkomatu — Zamówienie #${orderNumber || '?'}`,
      order_number: orderNumber || 'unknown',
      order_id: orderId || 'unknown',
      customer_email: customerEmail || 'unknown',
      pickup_method: selectedPoint.type === 'inpost' ? t.inpostLabel : t.orlenLabel,
      pickup_code: selectedPoint.code,
      pickup_name: selectedPoint.name,
      pickup_address: selectedPoint.address,
      timestamp: new Date().toISOString(),
      page_url: window.location.href
    };

    try {
      const res = await fetch(cfg.formspreeEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('Submit failed: ' + res.status);

      // Hide form, show success
      section.querySelector('.postpickup__methods').style.display = 'none';
      section.querySelectorAll('.delivery-picker__widget').forEach(w => w.style.display = 'none');
      selectionEl.style.display = 'none';
      continueBtn.style.display = 'none';
      section.querySelector('.postpickup__success').style.display = 'none';
      section.querySelector('.postpickup__order-info').style.display = 'none';
      finalEl.hidden = false;

      // Save flag so refresh doesn't show form again
      try {
        if (orderId) localStorage.setItem('postpickup-saved-' + orderId, '1');
      } catch (e) {}

      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });

    } catch (err) {
      console.error('[PostPickup] Save failed:', err);
      continueBtn.disabled = false;
      continueBtn.textContent = t.confirmBtn;
      alert(t.saveError + '\n\nKontakt: ' + cfg.contactEmail);
    }
  });

  // ===== Already saved? =====
  try {
    if (orderId && localStorage.getItem('postpickup-saved-' + orderId) === '1') {
      section.querySelector('.postpickup__methods').style.display = 'none';
      section.querySelectorAll('.delivery-picker__widget').forEach(w => w.style.display = 'none');
      selectionEl.style.display = 'none';
      continueBtn.style.display = 'none';
      section.querySelector('.postpickup__success').style.display = 'none';
      section.querySelector('.postpickup__order-info').style.display = 'none';
      finalEl.hidden = false;
    }
  } catch (e) {}

  // ===== Utils =====
  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
})();
